export default {"id":"6f45af1b","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}